// extracted by mini-css-extract-plugin
module.exports = {"notification":"_1FjCL","notification-wrapper":"g2SGS","notificationWrapper":"g2SGS","tooltip":"_2BCKe"};